import React from 'react'
import { useNavigate } from 'react-router-dom';
import EventList from './eventList';
import { Calendar, Plus } from '@phosphor-icons/react';
import { Banner } from '../../components';


const DraftEvent = ({ events, handleEdit, handleView, handleDelete, placeholderProps}) => {
  const navigate = useNavigate();

  return (
    <div>
      {events?.length > 0 ? (
        <EventList
          status="draft"
          events={events}
          handleView={handleView}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      ) : (
        <Banner
          icon={<Calendar size={32}/>}
          title="You have no events in draft!"
          content="Let’s create your event."
          ctaIcon={<Plus size={20} 
            color={'white'} />}
          cta="Create event"
          onClick={() => navigate('../event/create')}
          {...placeholderProps}
        />)}
    </div>
  )
}

export default DraftEvent;